// extracted by mini-css-extract-plugin
module.exports = {"title":"title--TDQLz","request":"request--VdlRu"};